import { LanguageCodes } from "Infrastructure/Api/Api";
import type { BlOption } from "Shared/Inputs/BlOption";

/**
 * Converts an enum to an array of BlOption using a translation function.
 *
 * @param enumObj - The enum object to convert
 * @param getTranslation - Function that returns translated label for each enum value
 * @returns Array of BlOption with value and translated label
 *
 * @example
 * const countryOptions = enumToCodeList(CountryCodes, (code) =>
 *   t(Resources.Common.Countries[code as keyof typeof Resources.Common.Countries])
 * );
 */
export function enumToCodeList<T extends Record<string, string>>(
  enumObj: T,
  getTranslation: (value: T[keyof T]) => string,
): BlOption[] {
  return Object.values(enumObj).map((value) => ({
    value,
    label: getTranslation(value as T[keyof T]),
  }));
}

export const LANGUAGE_LABELS: Record<LanguageCodes, string> = {
  [LanguageCodes.Czech]: "CZ",
  [LanguageCodes.English]: "EN",
  [LanguageCodes.Deutsch]: "DE",
  [LanguageCodes.French]: "FR",
  [LanguageCodes.Italian]: "IT",
  [LanguageCodes.Spanish]: "ES",
  [LanguageCodes.Polish]: "PL",
  [LanguageCodes.Dutch]: "NL",
  [LanguageCodes.Romanian]: "RO",
  [LanguageCodes.Hungarian]: "HU",
  [LanguageCodes.Portuguese]: "PT",
  [LanguageCodes.Swedish]: "SV",
  [LanguageCodes.Bulgarian]: "BG",
  [LanguageCodes.Danish]: "DA",
  [LanguageCodes.Finnish]: "FI",
  [LanguageCodes.Slovak]: "SK",
  [LanguageCodes.Croatian]: "HR",
  [LanguageCodes.Lithuanian]: "LT",
  [LanguageCodes.Slovenian]: "SL",
  [LanguageCodes.Latvian]: "LV",
  [LanguageCodes.Estonian]: "ET",
  [LanguageCodes.Greek]: "EL",
  [LanguageCodes.Maltese]: "MT",
  [LanguageCodes.Irish]: "GA",
};
